import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "history-hanging-incoming",
  class: "w-full h-full bg-gray-100 p-2"
}
const _hoisted_2 = { class: "flex flex-col gap-y-2 mb-2 h-full" }
const _hoisted_3 = { class: "flex flex-row items-center w-full justify-between" }
const _hoisted_4 = { class: "flex flex-row items-center gap-2.5" }
const _hoisted_5 = { class: "w-60 whitespace-nowrap" }
const _hoisted_6 = { class: "flex flex-row items-center gap-2.5" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", { class: "bg-white text-sm text-gray-lp-300 font-semibold" }, [
  /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-1/20 sticky top-0 bg-white" }, [
    /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " No ")
  ]),
  /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-6/20 sticky top-0 bg-white" }, [
    /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " Nama file ")
  ]),
  /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-5/20 sticky top-0 bg-white" }, [
    /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " Tanggal upload ")
  ]),
  /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-3/20 sticky top-0 bg-white" }, [
    /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " Status ")
  ]),
  /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-3/20 sticky top-0 bg-white" }, [
    /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " Jumlah file Geojson ")
  ]),
  /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-2/20 sticky top-0 bg-white" }, [
    /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " Atur ")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_12 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_13 = { class: "text-left px-3 py-3" }
const _hoisted_14 = { class: "flex flex-col items-start gap-1" }
const _hoisted_15 = { class: "text-black-lp-200" }
const _hoisted_16 = { class: "text-gray-lp-600" }
const _hoisted_17 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_18 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_19 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_20 = {
  key: 0,
  class: "px-3 bg-white rounded-2xl absolute bottom-5 left-2 right-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DownloadTemplate = _resolveComponent("DownloadTemplate")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["p-3 bg-white flex flex-col gap-y-2 rounded-2xl", `${ !_ctx.bulkListData.length && !_ctx.loading ? 'h-full' : '' }`]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Search, {
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              placeholder: "Cari nama file",
              class: "w-72 mr-4"
            }, null, 8, ["onInput", "onClear", "value"]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_CustomDropdown, {
                selectedItem: _ctx.uploadStatus,
                options: _ctx.statusData,
                placeholder: "Semua status",
                onSelect: _ctx.onChangeStatus
              }, null, 8, ["selectedItem", "options", "onSelect"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DownloadTemplate),
            _createVNode(_component_UploadFile, { onUpload: _ctx.onRefreshBulkList }, null, 8, ["onUpload"])
          ])
        ]),
        (_ctx.bulkListData.length || _ctx.loading)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "overflow-auto border-t border-b border-gray-lp-1400 relative",
              style: `max-height: calc(calc(100vh / var(--viewport-scale)) - ${ _ctx.isSidebarAndBreadcrumbV2 ? '290px' : '270px' });`
            }, [
              _createVNode("table", _hoisted_7, [
                _hoisted_8,
                (_ctx.loading)
                  ? (_openBlock(), _createBlock("tbody", _hoisted_9, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (index) => {
                        return _createVNode("tr", {
                          key: index,
                          class: "cursor-wait border-t border-gray-lp-1400"
                        }, [
                          (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (indexColumn) => {
                            return _createVNode("td", {
                              key: indexColumn,
                              class: "px-3 py-3"
                            }, [
                              _createVNode(_component_Skeleton, { height: "1.3rem" })
                            ])
                          }), 64))
                        ])
                      }), 64))
                    ]))
                  : (_openBlock(), _createBlock("tbody", _hoisted_10, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulkListData, (item, index) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: `history-incoming-${index}`,
                          class: "border-t border-gray-lp-1400 text-sm text-black-lp-200"
                        }, [
                          _createVNode("td", _hoisted_11, _toDisplayString(index + 1 + _ctx.offset), 1),
                          _createVNode("td", _hoisted_12, _toDisplayString(item.activityName), 1),
                          _createVNode("td", _hoisted_13, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.formatDateToString(item.createdAt)), 1),
                              _createVNode("span", _hoisted_16, _toDisplayString(item.createdBy), 1)
                            ])
                          ]),
                          _createVNode("td", _hoisted_17, [
                            _createVNode("div", {
                              class: `${_ctx.mapStatus(item.status).style} rounded-2xl py-0.5 px-2`,
                              style: {"width":"fit-content"}
                            }, _toDisplayString(_ctx.mapStatus(item.status).label), 3)
                          ]),
                          _createVNode("td", _hoisted_18, _toDisplayString(_ctx.totalFileGeojson(item)), 1),
                          _createVNode("td", _hoisted_19, [
                            _createVNode(_component_lp_button, {
                              outline: true,
                              iconLeft: !_ctx.isEnableDownload(item.status) ? 'ics_o_download_circle_disabled' : 'ics_o_download_circle',
                              title: "Download",
                              textColor: "red-lp-100",
                              color: "red-lp-100",
                              small: false,
                              customClass: "whitespace-no-wrap",
                              disabled: !_ctx.isEnableDownload(item.status),
                              onClick: 
                      (event) => {
                        _ctx.onDownloadData(item);
                        event.stopPropagation();
                      }
                    
                            }, null, 8, ["iconLeft", "disabled", "onClick"])
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ], 4))
          : (_ctx.errorCause || _ctx.noDataHasFilter)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 1,
                class: "h-full",
                errorType: _ctx.noDataHasFilter ? 'notfound' : _ctx.errorCause,
                onTryAgain: _ctx.getBulkList
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock(_component_EmptyState, {
                key: 2,
                class: "h-full",
                icon: "noData_empty",
                customHeaderMessage: "Data belum tersedia",
                customMessage: "Jika sudah ada data, maka akan muncul di sini secara otomatis."
              }))
      ], 2),
      (_ctx.bulkListData.length && !_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_20, [
            _createVNode(_component_PaginationV3, {
              pagination: _ctx.bulkListPagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.bulkListPagination = $event)),
              onSetPage: _ctx.toPageV3,
              renderedData: _ctx.bulkListData.length,
              paginationWidth: "w-full",
              paginationPaddingVertical: "py-1"
            }, null, 8, ["pagination", "onSetPage", "renderedData"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}